module.exports = __webpack_public_path__ + "img/JiaGuo.a7985952.jpg";